@file:kotlin.js.JsExport
/*
 * Copyright 2017-2020 Narbase technologies and contributors. Use of this source code is governed by the MIT License.
 */


package com.narbase.letsgo.web.routing.domain.helloworld

import com.narbase.letsgo.router.EndPoint


object HelloWorldEndPoint : EndPoint<HelloWorldEndPoint.Request, HelloWorldEndPoint.Response>() {
    class Request(
        val data: String? = null,
    )

    class Response(
        val data: String? = null,
    )
}

